import {} from "../routes/users/api/Representation";
export var AddressStatusEnum;
(function (AddressStatusEnum) {
    AddressStatusEnum["INVALID"] = "INVALID";
    AddressStatusEnum["VALIDATED"] = "VALIDATED";
})(AddressStatusEnum || (AddressStatusEnum = {}));
export var CountryCode;
(function (CountryCode) {
    CountryCode["AU"] = "AU";
    CountryCode["NZ"] = "NZ";
})(CountryCode || (CountryCode = {}));
export var DimensionUnitEnum;
(function (DimensionUnitEnum) {
    DimensionUnitEnum["M"] = "M";
    DimensionUnitEnum["CM"] = "CM";
    DimensionUnitEnum["MM"] = "MM";
})(DimensionUnitEnum || (DimensionUnitEnum = {}));
export var WeightUnitEnum;
(function (WeightUnitEnum) {
    WeightUnitEnum["TN"] = "TN";
    WeightUnitEnum["KG"] = "KG";
    WeightUnitEnum["GM"] = "GM";
})(WeightUnitEnum || (WeightUnitEnum = {}));
export var UnitOfMeasureEnum;
(function (UnitOfMeasureEnum) {
    UnitOfMeasureEnum["QUANTITY_EACH"] = "QUANTITY_EACH";
    UnitOfMeasureEnum["VOLUME_M3"] = "VOLUME_M3";
    UnitOfMeasureEnum["WEIGHT_TON"] = "WEIGHT_TON";
    UnitOfMeasureEnum["GROSS_TONNE"] = "GROSS_TONNE";
    UnitOfMeasureEnum["HOURS"] = "HOURS";
    UnitOfMeasureEnum["LOADS"] = "LOADS";
    UnitOfMeasureEnum["PALLET"] = "PALLET";
    UnitOfMeasureEnum["CARTON"] = "CARTON";
    UnitOfMeasureEnum["METRES_SQUARED"] = "METRES_SQUARED";
    UnitOfMeasureEnum["ITEM"] = "ITEM";
    UnitOfMeasureEnum["CONTAINER"] = "CONTAINER";
    UnitOfMeasureEnum["CRATE"] = "CRATE";
    UnitOfMeasureEnum["CASK"] = "CASK";
    UnitOfMeasureEnum["ROLL"] = "ROLL";
    UnitOfMeasureEnum["UNITS"] = "UNITS";
    UnitOfMeasureEnum["LITRES"] = "LITRES";
    UnitOfMeasureEnum["GENERAL_FREIGHT_ITEM"] = "GENERAL_FREIGHT_ITEM";
    UnitOfMeasureEnum["BULKA_BAG"] = "BULKA_BAG";
})(UnitOfMeasureEnum || (UnitOfMeasureEnum = {}));
export var CommunicationGatewayEnum;
(function (CommunicationGatewayEnum) {
    CommunicationGatewayEnum["SMS_BROADCAST"] = "SMS_BROADCAST";
    CommunicationGatewayEnum["MAILGUN"] = "MAILGUN";
    CommunicationGatewayEnum["SMTP"] = "SMTP";
    CommunicationGatewayEnum["PUSHY"] = "PUSHY";
    CommunicationGatewayEnum["FIREBASE"] = "FIREBASE";
})(CommunicationGatewayEnum || (CommunicationGatewayEnum = {}));
export var CommunicationStatusEnum;
(function (CommunicationStatusEnum) {
    CommunicationStatusEnum["SENT"] = "SENT";
    CommunicationStatusEnum["DELIVERED"] = "DELIVERED";
    CommunicationStatusEnum["FAILED"] = "FAILED";
    CommunicationStatusEnum["DROPPED"] = "DROPPED";
})(CommunicationStatusEnum || (CommunicationStatusEnum = {}));
export var EmailMessageAddressType;
(function (EmailMessageAddressType) {
    EmailMessageAddressType["TO"] = "TO";
    EmailMessageAddressType["FROM"] = "FROM";
    EmailMessageAddressType["CC"] = "CC";
    EmailMessageAddressType["BCC"] = "BCC";
})(EmailMessageAddressType || (EmailMessageAddressType = {}));
export var ImageUsageType;
(function (ImageUsageType) {
    ImageUsageType["TO"] = "TO";
    ImageUsageType["FROM"] = "FROM";
    ImageUsageType["CC"] = "CC";
    ImageUsageType["BCC"] = "BCC";
})(ImageUsageType || (ImageUsageType = {}));
export var ImportFormatEnum;
(function (ImportFormatEnum) {
    ImportFormatEnum["CONSIGNMENT_LINES"] = "CONSIGNMENT_LINES";
    ImportFormatEnum["SALES_ORDER_LINES"] = "SALES_ORDER_LINES";
    ImportFormatEnum["FREIGHT_TRACKING_LINES"] = "FREIGHT_TRACKING_LINES";
})(ImportFormatEnum || (ImportFormatEnum = {}));
export var DocumentUsage;
(function (DocumentUsage) {
    DocumentUsage["CHECKLIST"] = "CHECKLIST";
    DocumentUsage["TENANT_INSURANCE_POLICY"] = "TENANT_INSURANCE_POLICY";
    DocumentUsage["VEHICLE_FEATURE"] = "VEHICLE_FEATURE";
    DocumentUsage["DRIVER_FEATURE"] = "DRIVER_FEATURE";
    DocumentUsage["SALES_ORDER_ATTACHMENT"] = "SALES_ORDER_ATTACHMENT";
})(DocumentUsage || (DocumentUsage = {}));
export class UploadFileTransformer {
    static fromDocumentResponse(doc, contentsUri) {
        return {
            uid: `doc-${doc.id}`,
            name: doc.name,
            size: doc.size,
            status: 'done',
            url: contentsUri,
            thumbUrl: "",
            type: doc.mimeType,
            response: {
                id: doc.id,
                name: doc.name,
                size: doc.size,
                mimeType: doc.mimeType,
                contentsUri: contentsUri
            }
        };
    }
}
